<script setup lang="ts">
import type { Schemas } from "#shopware";
const props = withDefaults(
  defineProps<{
    activeCategory: Schemas["Category"];
    elements: Schemas["Category"][];
    level: number;
  }>(),
  {
    level: 0,
  }
);

function getHighlightCategory(navigationElement: Schemas["Category"]) {
  return (
    (props.activeCategory?.path || "").includes(navigationElement.id) ||
    navigationElement.id === props.activeCategory?.id
  );
}
</script>
<template>
  <div>
    <ul v-if="props.elements?.length" class="flex flex-col gap-y-3.5 prose-li:relative prose-li:flex prose-li:gap-x-2.5 [&>li>label]:py-0.5 [&>li>label]:flex-1 [&>li>input]:opacity-0 [&>li>input]:cursor-pointer [&>li>input]:absolute [&>li>input]:w-full [&>li>input]:left-0 [&>li>span]:w-5 [&>li>span]:h-5 [&>li>span]:inline-block [&>li>span]:text-[0] [&>li>input:checked+span]:text-sm [&>li>span]:border [&>li>span]:rounded">
      <li v-for="(navigationElement, index) in props.elements" :key="index">
        <ListingFiltersSwCategoryNavigationLink
          :navigation-element="navigationElement"
          :is-highlighted="getHighlightCategory(navigationElement)"
          :is-active="navigationElement.id === props.activeCategory?.id"
        />
        <SwCategoryNavigation
          v-if="navigationElement.children"
          :elements="navigationElement.children"
          :active-category="props.activeCategory"
          :level="props.level + 1"
        />
      </li>
    </ul>
  </div>
</template>
